import styled from 'styled-components'
import AntdDivider from 'antd/lib/divider'
import { WHITE, GRAY, GRAY_DARK } from '../../../theme/colors'

export const OptionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
`

export const Options = styled.div`
  margin-right: 12px;
  border: ${({ disabled }: OptionsProps) => (disabled ? `1px solid ${GRAY_DARK}` : `1px solid #a9a9a9`)};
  border-radius: 4px;
  padding: 4px 10px;
`

export const OptionsGuidelines  = styled.div`
  margin-right: 12px;
  border: ${({ active }: OptionsProps) => (active ? `1px solid #4b90e2` : `1px solid #a9a9a9`)};
  border-radius: 4px;
  padding: 4px;
`

interface OptionsProps {
  withMargin?: boolean
  disabled?: boolean
  active?: boolean
}

export const OptionButton = styled.div`
  width: 27px;
  user-select: none;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }: OptionsProps) =>
    disabled ? 'not-allowed' : 'pointer'};
  margin: ${({ withMargin }: OptionsProps) =>
    withMargin ? '16px 0px' : '0px'};
`

export const GuideButton = styled.div`
  user-select: none;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    filter: saturate(var(--value, 5))
  }
`

export const ToolTipText = styled.div`
  text-align: center;
`

export const ControlIcon = styled.img`
  padding: 5px;
  width: 26px;
  filter: ${({ active }: OptionsProps) =>
    active ? 'invert(60%)' : 'unset'};
`

export const Divider = styled(AntdDivider)`
  margin: 0px;
  user-select: none;
`

export const ClearPlaceholderIcon = styled.img`
  width: 30px;
`

export const OptionName = styled.p`
  font-size: 10px;
  color: ${({ disabled }: OptionsProps) => (disabled ? GRAY : WHITE)};
  margin: 0;
  padding: 0 5px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/OptionsControllerV1/styledComponents.tsx